import React from "react"
import autobind from "class-autobind"
import strings from "../../../localization/strings"
import { Dialog, FlatButton } from "material-ui"
import { ISchedulePatternTemplate } from "../../../models"
import DayTimelineBar from "../../../components/schedule/DayTimelineBar"
import AssignEmployeeSelectDays from "./AssignEmployeeSelectDays"

interface IProps {
  availablePatternTemplates: ISchedulePatternTemplate[]
  fixedDay: ISchedulePatternTemplate
  selectedDays: ISchedulePatternTemplate[]
  handleClose(): void
  handleSave(selectedDays: ISchedulePatternTemplate[]): void
}
interface IState {
  selectedDays: ISchedulePatternTemplate[]
}

export default class SelectAdditionalDaysDialog extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props)
    this.state = {
      selectedDays: props.selectedDays
    }
    autobind(this)
  }

  render() {
    return (
      <Dialog
        open
        title={strings.Select_Additional_Days}
        titleStyle={{ paddingLeft: 35, paddingBottom: 10 }}
        actions={[
          <FlatButton
            data-intercom-target={"SelectAdditionalDaysDialog-Btn-Close"}
            label={strings.CANCEL}
            secondary
            onClick={this.props.handleClose}
          />,
          <FlatButton
            data-intercom-target={"SelectAdditionalDaysDialog-Btn-Save"}
            label={strings.SAVE}
            primary
            onClick={() => this.props.handleSave(this.state.selectedDays)}
          />
        ]}
      >
        <div style={{ marginTop: 20, paddingRight: 20, paddingLeft: 20 }}>
          <AssignEmployeeSelectDays
            availableDays={this.props.availablePatternTemplates}
            fixedDay={this.props.fixedDay}
            selectedDays={this.state.selectedDays}
            handleSelectDays={selectedDays => this.setState({ selectedDays })}
          />
          <div style={{ height: 150 }}>
            <div style={{ color: "rgb(97, 97, 97)", marginBottom: 10 }}>{strings.Shift_information}</div>
            <DayTimelineBar
              shiftTemplates={this.props.fixedDay.ShiftTemplates}
              totalWidth={888}
            />
          </div>
        </div>
      </Dialog>
    )
  }
}